import React from 'react';
export function AboutSection() {
  return <section className="py-20 bg-brand-dark" data-id="element-1">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-2">
        <div className="flex flex-col md:flex-row items-center gap-12 bg-gradient-to-r from-brand-card to-black p-8 md:p-12 rounded-2xl border border-white/5" data-id="element-3">
          <div className="md:w-1/3 flex justify-center" data-id="element-4">
            <div className="relative" data-id="element-5">
              <div className="absolute inset-0 bg-brand-gold/20 rounded-full blur-xl" data-id="element-6"></div>
              <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1976&auto=format&fit=crop" alt="Carmen Otero" className="w-48 h-48 object-cover rounded-full border-2 border-brand-gold/50 relative z-10 filter grayscale contrast-125" data-id="element-7" />
            </div>
          </div>
          <div className="md:w-2/3 text-center md:text-left" data-id="element-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-9">
              Conoce a Carmen Otero
            </h2>
            <p className="text-brand-gold font-medium mb-4 text-sm uppercase tracking-widest" data-id="element-10">
              Investigadora & Formuladora Botánica
            </p>
            <p className="text-gray-400 font-light text-sm leading-relaxed mb-4" data-id="element-11">
              "No nací siendo experta. Nací siendo una mujer desesperada
              ocultando calvas bajo peinados tirantes. La industria me falló.
              Los dermatólogos me recetaron químicos de por vida."
            </p>
            <p className="text-gray-400 font-light text-sm leading-relaxed" data-id="element-12">
              Me sumergí en la botánica ancestral y descubrí el mecanismo de la{' '}
              <strong className="text-white" data-id="element-13">
                Bio-Activación Termo-Génica
              </strong>
              . Tras perfeccionar las proporciones exactas del extracto de
              jengibre, no solo recuperé mi cabello, sino que formulé un
              protocolo replicable que hoy funciona para cientos de mujeres que
              se negaron a rendirse.
            </p>
          </div>
        </div>
      </div>
    </section>;
}